import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, delay, map, retryWhen, tap, throwError, timeout, finalize } from 'rxjs';
import { EventsService } from '../services/events/events.service';

export const HttpRequestInterceptor: HttpInterceptorFn = (req, next) => {
  const events = inject(EventsService);
  const isLoginRequest = /\/login\/?$/.test(req.url);

  if (isLoginRequest) {
    return next(req).pipe(
      timeout(25000),
      catchError((err) => throwError(() => err)),
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status >= 500 || err.status === 0) {
            events.publish('internet:offline', {});
          }
          if (err.status === 401) {
            if (err.url && !skip401error(err.url)) {
              events.publish('usuario:nao_autorizado', {});
            }
          }
        } else {
          events.publish('internet:offline', {});
        }
        throw err.error;
      }),
      finalize(() => {})
    );
  }

  return next(req).pipe(
    timeout(25000),
    catchError((err) => throwError(() => err)),
    retryWhen((err) => {
      let retries = 1;
      return err.pipe(
        delay(2000),
        tap(() => {}),
        map((error) => {
          if ((error as HttpErrorResponse).status >= 400 && (error as HttpErrorResponse).status < 500) {
            throw error;
          }
          if (retries++ === 3) {
            throw error;
          }
          return error;
        })
      );
    }),
    catchError((err) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status >= 500 || err.status === 0) {
          events.publish('internet:offline', {});
        }
        if (err.status === 401) {
          if (err.url && !skip401error(err.url)) {
            events.publish('usuario:nao_autorizado', {});
          }
        }
      } else {
        events.publish('internet:offline', {});
      }
      throw err.error;
    }),
    finalize(() => {})
  );
};

function skip401error(url: string): boolean {
  if (/pagamentoswebhook/i.test(url)) {
    return true;
  }
  if (/\/sessao\/?$/i.test(url)) {
    return true;
  }
  const urlParts = url.split('/');
  switch (urlParts[4]) {
    default:
      return false;
  }
}
